/* eslint-disable solid/no-innerhtml */
import type { formTypes, updateHandler } from '@/web-components/BapFormApp/BapFormApp'
import type { CompaniesSchema } from '@/web-components/BapFormApp/BapFormSchema'
import { createEffect, For } from 'solid-js'
import { z } from 'zod'

type FormBapByCompanyProps = {
  companies: z.infer<typeof CompaniesSchema> | undefined
  updateHandler: updateHandler
  activeForm: formTypes | undefined
}
export function FormBapByCompany(props: FormBapByCompanyProps) {
  let companySelect: HTMLSelectElement
  createEffect(() => {
    if (props.activeForm === 'category') {
      companySelect.selectedIndex = 0
    }
  })
  return (
    <form action="" class="">
      <label class="mb-2 block font-bold" for="bap-companies">
        Search by Company
      </label>
      <div class="flex max-md:max-w-md max-md:flex-wrap">
        <div class="relative w-full max-md:w-full">
          <select
            name="bap-companies"
            id="bap-companies"
            class="max-md:border-b-0 md:border-r-0 block h-64 w-full max-w-full rounded-none border border-black p-16 pr-40 leading-130% max-md:w-full"
            ref={(e) => (companySelect = e)}
          >
            <option selected value="">
              Select Company
            </option>
            <For each={props.companies}>
              {(company) => <option value={company.id} innerHTML={company.title.rendered} />}
            </For>
          </select>
        </div>
        <button
          class="btn w-full max-w-100 rounded-none"
          onClick={(e) => {
            e.preventDefault()

            if (companySelect.value) {
              props.updateHandler({
                companies: [Number(companySelect.value)],
                form: 'company',
              })
            }
          }}
        >
          GO
        </button>
      </div>
    </form>
  )
}
